import axios from "axios";

class request {

	apiUrl = "";
    defToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJFZmlzZW5zZSIsImF1ZCI6ImVmaXNlbnNlLmNvbSIsInN5c3RlbSI6InBvcnRhbCIsImlhdCI6MTcwNzkwMDE1NywiZXhwIjoxODAyNTA4MTU3LCJyb2xlIjoiYWRtaW4iLCJuYW1lIjoiRWZpc2Vuc2UiLCJsYXN0bmFtZSI6IlNvcG9ydGUiLCJpZExpY2Vuc2UiOiIxIiwidXJpIjoiIiwidG9rZW4iOiJVa3N4YkNNaFZXSlhlVFkwWmpSbE5qWXhNV0ptWkdRMUxqTXhNRFUxT0RRMSIsInN0b3JlcyI6eyI2MDEyIjoiNjAxMiJ9LCJzdG9yZSI6IjYwMTIifQ.UB1_AKmdAW3U91jJVZC6B6_n9cC7K2qYh57RGQb7JYQ";

	settings = {}

	defSettings = {
		"url": "",
		"method": "GET",
		"timeout": 0,
	}

	constructor(api) {
		this.apiUrl = api;
	}

	jsonRequest = (req, parameter = null) => {

		this.settings = {};

		switch (req) {

			case "getCities":
				this.settings = {...this.defSettings};
				this.settings["method"] = "GET";
				this.settings["url"] = this.apiUrl + "/apiCRM/efisenseHub/v2/Citie";
				if(parameter != null){
					this.settings["headers"] = { 
						"Content-Type": "application/json",
						"Authorization": "Bearer " + parameter
					}
				}else{
					this.settings["headers"] = { 
						"Content-Type": "application/json",
					}
				}
				break;

			case "setPaymentIntent":
				this.settings = {...this.defSettings};
				this.settings["method"] = "POST";
				this.settings["url"] = this.apiUrl + "/apiCRM/stripe/Payments/setPaymentIntent";
				this.settings["headers"] = { 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + parameter.token
				}
				this.settings["data"] = JSON.stringify(parameter.data);
				break;

			case "checkCodeValidation":
				this.settings = {...this.defSettings};
				this.settings["method"] = "POST";
				this.settings["url"] = this.apiUrl + "/apiCRM/EfisenseHub/v2/Login/confirmExistentCode";
				this.settings["headers"] = { 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + parameter.token
				}
				this.settings["data"] = JSON.stringify(parameter.data);
				break;

			case "processLogin":
				this.settings = {...this.defSettings};
				this.settings["method"] = "POST";
				this.settings["url"] = this.apiUrl + "/apiCRM/EfisenseHub/v2/Login/sendVerificationCode";
				this.settings["headers"] = { 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + parameter.token
				}
				this.settings["data"] = JSON.stringify(parameter.data);
				break;

			case "getLogin":
				this.settings = {...this.defSettings};
				this.settings["method"] = "POST";
				this.settings["url"] = this.apiUrl + "/apiCRM/EfisenseHub/v2/Login/tryLogin";
				this.settings["headers"] = { 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + parameter.token
				}
				this.settings["data"] = JSON.stringify(parameter.data);
				break;

			case "sendOrder":
				this.settings = {...this.defSettings};
				this.settings["method"] = "POST";
				this.settings["url"] = this.apiUrl + "/apiCRM/EfisenseHub/v2/GiftCard/Sale";
				this.settings["headers"] = { 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + parameter.token
				}
				this.settings["data"] = JSON.stringify(parameter.data);
				break;

			default:
				return false
		}
		return this.settings
	}


	/* usuario */

	sendOrder = (data = null) => {
		let json = this.jsonRequest("sendOrder", data);
		return this.petition(json, false)
	}

	getCities = (data = null) => {
		let json = this.jsonRequest("getCities", data);
		return this.petition(json, false)
	}

	getLogin = (data = {}) => {
		let json = this.jsonRequest("getLogin", data);
		return this.petition(json, false)
	}

	processLogin = (data = {}) => {
		let json = this.jsonRequest("processLogin", data);
		return this.petition(json, false)
	}

	setPaymentIntent = (data = {}) => {
		let json = this.jsonRequest("setPaymentIntent", data);
		return this.petition(json, false)
	}

	checkCodeValidation = (data = {}) => {
		let json = this.jsonRequest("checkCodeValidation", data);
		return this.petition(json, false)
	}

	petition = async (json, watch=true) => {
		return new Promise(function(resolve, reject) {
			if(json){
				axios(json)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					if(watch){
						console.log(error);
					}
					reject(error);
				})
			}else{
				let response = {data:false,code:500}
				resolve(response);
			}
		});
	}
}


export { request };
